"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityPanels = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const sparkline_1 = __importDefault(require("@fnando/sparkline"));
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
    <div class="text-center p-4">
        <app-loader block="true" width="16px" height="16px"></app-loader>
    </div>
`)}

${(0, fast_element_1.when)(x => !x.loading && x.panels.length === 0, (0, fast_element_1.html) `
    <div class="activity-empty-state">
        <i class="iconsminds-statistic text-muted"></i>
        <p class="text-muted">${'activities.panel.noData'.t()}</p>
    </div>
`)}

${(0, fast_element_1.when)(x => !x.loading && x.panels.length > 0, (0, fast_element_1.html) `
    <div id="activity_panels" class="row g-3">
        ${(0, fast_element_1.repeat)(x => x.panels, (0, fast_element_1.html) `
            <div data-panelId="${(x, c) => c.index}" class="a-panel col-md-4">
                <div class="card p-3 pb-2 h-100">
                    <div class="d-flex justify-content-between align-items-start mb-3">
                        <div class="d-flex align-items-center gap-2">
                            <span class="d-flex align-items-center justify-content-center rounded-circle ${(p, c) => c.parent.getPanelBgClass(p.commsType)}" style="width: 40px; height: 40px;">
                                <i class="${(p, c) => c.parent.getPanelIcon(p.commsType)} ${(p, c) => c.parent.getPanelIconClass(p.commsType)}"></i>
                            </span>
                            <div>
                                <div class="fw-bold">${p => p.title}</div>
                            </div>
                        </div>
                    </div>

                    <div class="capsules row row-cols-2 g-2">
                        <div class="col-6">
                            <div class="capsule bg-light rounded p-2 h-100">
                                <div class="text-uppercase text-muted" style="font-size: 10px;">${(p, c) => c.parent.getGroupsLabel(p.commsType)}</div>
                                <div class="d-flex align-items-center justify-content-between">
                                    <span class="fw-bold fs-5">${p => p.groupsCount}</span>
                                    <span class="bg-success rounded-circle" style="width: 8px; height: 8px;"></span>
                                </div>
                                <div class="small text-success">${(p, c) => c.parent.getGroupsActiveLabel(p.commsType)}</div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="capsule bg-light rounded p-2 h-100">
                                <div class="text-uppercase text-muted" style="font-size: 10px;">${'activities.panel.critical'.t()}</div>
                                <div class="d-flex align-items-center justify-content-between">
                                    <span class="fw-bold fs-5 ${p => p.criticalCount > 0 ? 'text-danger' : 'text-muted'}">${p => p.criticalCount}</span>
                                    <i class="iconsminds-danger ${p => p.criticalCount > 0 ? 'text-danger' : 'text-muted'}"></i>
                                </div>
                                <div class="small ${p => p.criticalCount > 0 ? 'text-danger' : 'text-muted'}">
                                    ${p => p.criticalCount > 0 ? 'activities.panel.criticalDetected'.t() : 'activities.panel.noAlerts'.t()}
                                </div>
                            </div>
                        </div>
                        <div class="col-6 mt-3">
                            <div class="capsule bg-light rounded p-2 h-100">
                                <div class="text-uppercase text-muted" style="font-size: 10px;">${(p, c) => c.parent.getWarningLabel(p.commsType)}</div>
                                <div class="d-flex align-items-center justify-content-between">
                                    <span class="fw-bold fs-5 ${p => p.warningCount > 0 ? 'text-warning' : 'text-muted'}">${p => p.warningCount}</span>
                                    <i class="iconsminds-danger ${p => p.warningCount > 0 ? 'text-warning' : 'text-muted'}"></i>
                                </div>
                                <div class="small ${p => p.warningCount > 0 ? 'text-warning' : 'text-muted'}">
                                    ${p => p.warningCount > 0 ? 'activities.panel.warning'.t() : 'activities.panel.noWarnings'.t()}
                                </div>
                            </div>
                        </div>
                        <div class="col-6 mt-3">
                            <div class="capsule bg-light rounded p-2 h-100">
                                <div class="text-uppercase text-muted" style="font-size: 10px;">${'activities.panel.status'.t()}</div>
                                <div class="fw-bold ${(p, c) => c.parent.getStatusClass(p)}">${(p, c) => c.parent.getStatusLabel(p)}</div>
                                <svg width="60" height="20" stroke-width="2" class="activity-sparkline" data-values="${p => JSON.stringify(p.sparklineValues || [])}" data-color="${(p, c) => c.parent.getSparklineColor(p)}"></svg>
                            </div>
                        </div>
                    </div>

                    <div class="small text-muted text-end fst-italic mt-2 mb-0">
                        <small>${'activities.panel.lastSync'.t()}: ${(p, c) => c.parent.formatLastSync(p.lastSyncTimestamp)}</small>
                    </div>
                </div>
            </div>
        `, { positioning: true })}
    </div>
`)}
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
}

.activity-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #6c757d;
}
.activity-empty-state i {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.activity-sparkline {
  display: inline-block;
  width: 60px;
  height: 20px;
  background: transparent;
}

#activity_panels .capsules .capsule {
  padding: 10px 15px !important;
}
#activity_panels .capsules .capsule span + i {
  font-size: 1.5rem;
}
#activity_panels .a-panel span > i {
  font-size: 1.8rem;
}`;
const shadowOptions = { "mode": "open" };
let ActivityPanels = class ActivityPanels extends client_1.RWSViewComponent {
    constructor(wsService) {
        super();
        this.wsService = wsService;
        this.panels = [];
        this.loading = false;
        this._reloadHandler = null;
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadStats();
        this.setupWsListener();
        this._reloadHandler = () => { this.loadStats(); };
        window.addEventListener('activity-panels:reload', this._reloadHandler);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this._reloadHandler) {
            window.removeEventListener('activity-panels:reload', this._reloadHandler);
            this._reloadHandler = null;
        }
    }
    setupWsListener() {
        this.wsService.listenForMessage('comms_point', () => { this.loadStats(); }, 'comms_track_log_created');
    }
    async loadStats() {
        this.loading = true;
        try {
            const response = await this.apiService.back.get('whatsapp.activities.stats');
            if (response && response.success && Array.isArray(response.data)) {
                this.panels = response.data;
            }
            else {
                this.panels = [];
            }
        }
        catch (e) {
            console.error(e);
            this.panels = [];
        }
        finally {
            this.loading = false;
        }
    }
    getPanelIcon(commsType) {
        if (commsType === 'WA')
            return 'iconsminds-speach-bubbles';
        if (commsType === 'TELE')
            return 'iconsminds-speach-bubble-3';
        return 'iconsminds-mail';
    }
    getPanelIconClass(commsType) {
        if (commsType === 'WA')
            return 'text-success';
        if (commsType === 'TELE')
            return 'text-primary';
        return 'text-info';
    }
    getPanelBgClass(commsType) {
        if (commsType === 'WA')
            return 'bg-success-subtle';
        if (commsType === 'TELE')
            return 'bg-info-subtle';
        return 'bg-info-subtle';
    }
    getGroupsLabel(commsType) {
        if (commsType === 'WA')
            return 'activities.panel.groups'.t();
        if (commsType === 'TELE')
            return 'activities.panel.channels'.t();
        return 'activities.panel.inboxes'.t();
    }
    getGroupsActiveLabel(commsType) {
        if (commsType === 'EMAIL')
            return 'activities.panel.connectionActive'.t();
        return 'activities.panel.trackingEnabled'.t();
    }
    getWarningLabel(commsType) {
        if (commsType === 'EMAIL')
            return 'activities.panel.spamQueue'.t();
        return 'activities.panel.requiresAction'.t();
    }
    getStatusLabel(panel) {
        if (panel.status === 'danger')
            return 'activities.panel.status.danger'.t();
        if (panel.status === 'warning')
            return 'activities.panel.status.warning'.t();
        return 'activities.panel.status.good'.t();
    }
    getStatusClass(panel) {
        if (panel.status === 'danger')
            return 'text-danger';
        if (panel.status === 'warning')
            return 'text-warning';
        return 'text-success';
    }
    getSparklineColor(panel) {
        if (panel.status === 'danger')
            return '#dc3545';
        if (panel.status === 'warning')
            return '#ffc107';
        return '#198754';
    }
    formatLastSync(isoTimestamp) {
        if (!isoTimestamp)
            return 'activities.panel.neverSynced'.t();
        const diff = Date.now() - new Date(isoTimestamp).getTime();
        const minutes = Math.floor(diff / 60000);
        if (minutes < 1)
            return 'activities.panel.justNow'.t();
        if (minutes < 60)
            return 'activities.panel.minutesAgo'.t() + ' ' + minutes + ' min';
        const hours = Math.floor(minutes / 60);
        if (hours < 24)
            return 'activities.panel.hoursAgo'.t() + ' ' + hours + 'h';
        return 'activities.panel.daysAgo'.t() + ' ' + Math.floor(hours / 24) + 'd';
    }
    async refresh() {
        await this.loadStats();
    }
    applySparklineColor(el, color) {
        if (!color)
            return;
        const linePath = el.querySelector('.sparkline--line');
        const fillPath = el.querySelector('.sparkline--fill');
        const spotEl = el.querySelector('.sparkline--spot');
        if (linePath) {
            linePath.style.stroke = color;
        }
        if (fillPath) {
            fillPath.style.fill = color;
            fillPath.style.opacity = '0.3';
        }
        if (spotEl) {
            spotEl.style.stroke = color;
            spotEl.style.fill = color;
        }
    }
    panelsChanged(oldValue, newValue) {
        if (newValue && newValue.length > 0) {
            setTimeout(() => {
                this.setSparkline();
            }, 1000); // Trigger a re-render to ensure the sparkline is drawn after the DOM updates
        }
    }
    setSparkline() {
        var _a;
        const sparklineElements = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.activity-sparkline');
        if (sparklineElements) {
            sparklineElements.forEach((el) => {
                const sparklineValues = el.dataset.values && el.dataset.values.length ? JSON.parse(el.dataset.values) : [];
                const sparklineColor = el.dataset.color;
                if (el && sparklineValues) {
                    (0, sparkline_1.default)(el, sparklineValues);
                    this.applySparklineColor(el, sparklineColor);
                }
            });
        }
    }
};
exports.ActivityPanels = ActivityPanels;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ActivityPanels.prototype, "panels", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ActivityPanels.prototype, "loading", void 0);
exports.ActivityPanels = ActivityPanels = __decorate([
    (0, client_1.RWSView)('activity-panels', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(nest_interconnectors_1.WSService)),
    __metadata("design:paramtypes", [typeof (_a = typeof nest_interconnectors_1.WSServiceInstance !== "undefined" && nest_interconnectors_1.WSServiceInstance) === "function" ? _a : Object])
], ActivityPanels);
ActivityPanels.defineComponent();
